import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { ELUCIDATA_PRODUCT_EMAIL, POLLYPHI_DEPRECATED_TEXT, POLLYPHI_WEBINAR_YOUTUBE_URL } from '../../../../polly-manage.constants';

@Component({
  selector: 'app-polly-manage-deprecated-app',
  templateUrl: './polly-manage-deprecated-app.component.html',
  styleUrls: ['./polly-manage-deprecated-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PollyManageDeprecatedAppComponent {

  public showModal: boolean = true;
  public phiDeprecatedText: string[] = POLLYPHI_DEPRECATED_TEXT;
  public productEmail: string = ELUCIDATA_PRODUCT_EMAIL;
  public pollyphiWebinarUrl: string = POLLYPHI_WEBINAR_YOUTUBE_URL;

  @Input() public appName: string | undefined;
  @Output() public closeComponent: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * This function will emit state of the component
   */
  public closeDialog(): void {
    this.closeComponent.emit(false);
  }

}
